import './accountEnd.css';
import { useState, useEffect, useContext } from 'react';
import AccountRoute from './AccountRoute';
import {fetchPostAufa} from '../../../../faetures/fetch';
import { AppContext } from '../../../desktop/AppProviderDesktop';
import SelectAndInput from '../../../design/SelectAndInput';


function AccountEnd ({namesToPaid, setNamesToPaid, namesToSelect, num_of_docket, namesInvoices, setNamesInvoices, names, dataAccount, 
    organizeDataToSendToServer, setMassage, updateDataDocketList, idAufa, projectId, setSelectRadio}) {

    const [numOfRoute, setNumOfRoute] = useState(0);
    const [inputData, setInputData] = useState({sum: '', coin: 'USD', name: '', date: new Date().toISOString().slice(0, 10)});
    const [dataToPayment, setDataToPayment] = useState({});

    let {dollarGate} = useContext(AppContext);
    dollarGate *= 1.015;

    useEffect(() => {
        let sum3 = 0;
        let name = '';

        for (const numName in namesToSelect) {
            if (namesToSelect[numName].select) {
                sum3 += (namesToSelect[numName].radio === '1' ? dataAccount.sum : dataAccount.sumR) - (numName in namesToPaid ? namesToPaid[numName] : 0);
                (name === '') && (name = names[numName]['name']);
            }
        }

        setInputData({date: inputData.date, sum: String(sum3), name: name, coin: 'USD'});

    }, [namesToSelect]);

    const createPayment = () => {
        if (!dataToPayment.fun(dataToPayment) || inputData.sum == '' || inputData.sum < 0 || inputData.name == "") {
            return false;
        }

        let sum3 = Number(cleanAndFormatNumber(inputData.coin === "USD" ? inputData.sum : inputData.sum / dollarGate));
        let namesTopaid3 = {};
        let namesToPaidUpdate = {};

        const namesbuySumPrice = {};

        for (const numName in namesToSelect) {
            if (namesToSelect[numName].select) {
                let sum = dataAccount.sum;
                (numName in namesToPaid) && (sum -= namesToPaid[numName]);
                (sum > 0) && (namesbuySumPrice[numName] = sum);
            }
        }

        let num = Object.keys(namesbuySumPrice).length;

        while (num > 0) {
            let p1 = sum3 / num;

            let delete_names = [];

            Object.entries(namesbuySumPrice).map(([key, value]) => {
                if (value < p1) {
                    namesTopaid3[key] = value + (key in namesTopaid3 ? namesTopaid3[key] : 0);
                    sum3 -= value;
                    delete_names.push(key)
                }
            })

            if (delete_names.length > 0) {
                delete_names.map((key) => {
                    delete namesbuySumPrice[key];
                })
                num = Object.keys(namesbuySumPrice).length;

            } else {
                Object.entries(namesbuySumPrice).map(([key, value]) => {
                    namesTopaid3[key] = p1 + (key in namesTopaid3 ? namesTopaid3[key] : 0);
                    sum3 -= p1;
                })

                num = 0;
            }
        }

        if (sum3 > 0) {
            let namesToSelectWithZero = [];
            
            Object.keys(namesToSelect).map((key) => {
                if (namesToSelect[key].select) {
                    namesToSelectWithZero.push(key);
                }
            })

            let num = namesToSelectWithZero.length;
            let p1 = sum3 / num;

            namesToSelectWithZero.map((key) => {
                namesTopaid3[key] = p1 + (key in namesTopaid3 ? namesTopaid3[key] : 0);
            })
        }

        Object.entries(namesTopaid3).map(([key, value]) => {
            namesToPaidUpdate[key] = value + (key in namesToPaid ? namesToPaid[key] : 0);
        })

        let dataToSend = {namesAndSum:  namesTopaid3, name: inputData.name, date: inputData.date, sum: inputData.sum,
        type: numOfRoute, num_of_docket: num_of_docket, coin: inputData.coin, data: organizeDataToSendToServer(), dataToPayment: dataToPayment};

        setInputData({...inputData, sum: '0'});
        setSelectRadio();

        fetchPostAufa('pay', JSON.stringify(dataToSend)).then((resolve) => {
            setMassage({open: true, text: ""});

            if (typeof resolve === 'object' && resolve !== null) {
                if (resolve['status'] === 1) {
                    setMassage({open: true, text: "יש שינויים במחיר, יש להקיש שוב על קבל מחיר"});
                } else if (resolve['status'] === 0) {
                    setMassage({open: true, text: "שגיאה"});
                } else if (resolve['status'] === 2) {
                    setMassage({open: true, text: "תשלום עבר בהצלחה"});
                    updateDataDocketList('accounts', resolve['invoices']);
                    setNamesToPaid({...namesToPaid, ...namesToPaidUpdate});
                    setNamesInvoices({...namesInvoices, [resolve['num_invoices']]: namesTopaid3});
                } else if (resolve['status'] === 4) {
                    setMassage({open: true, text: resolve['data']});
                }
            } else {
                setMassage({open: true, text: "שגיאה"});
            }
        })
        // }).catch(({open: true, text: "שגיאה"}))
    }

    function changeRate(event) {

        if (event.target.value === 'ILS') {
            setInputData({...inputData, sum: inputData.sum * dollarGate, coin: event.target.value});
        } else {
            setInputData({...inputData, sum: inputData.sum / dollarGate, coin: event.target.value});
        }
    }

    const cleanAndFormatNumber = input => {
        let value = String(input);
        // Remove any non-digit characters except for '.' (decimal point)
        let cleaned = value.replace(/[^\d.]/g, '');
        
        // Check if there is a decimal point
        let decimalIndex = cleaned.indexOf('.');
        
        // If there is a decimal point and there are more than 2 digits after it, truncate to 2 decimal places
        if (decimalIndex !== -1) {
            let integerPart = cleaned.substring(0, decimalIndex);
            let decimalPart = cleaned.substring(decimalIndex + 1);
            cleaned = integerPart + '.' + decimalPart.slice(0, 2); // keep only up to 2 decimal places
        }
    
        // Return the cleaned and formatted number
        return cleaned;
    };

    return (<>
        <div className={'account-aufa-end-head'}>
            <p className={numOfRoute === 0 ? 'account-aufa-route-click' : ''} onClick={() => setNumOfRoute(0)}>מזומן</p>
            <p className={numOfRoute === 1 ? 'account-aufa-route-click' : ''} onClick={() => setNumOfRoute(1)}>כרטיס אשראי</p>
            <p className={numOfRoute === 2 ? 'account-aufa-route-click' : ''} onClick={() => setNumOfRoute(2)}>העברה בנקאית</p>
            <p className={numOfRoute === 3 ? 'account-aufa-route-click' : ''} onClick={() => setNumOfRoute(3)}>צ'קים</p>
            <p className={numOfRoute === 4 ? 'account-aufa-route-click' : ''} onClick={() => setNumOfRoute(4)}>שובר</p>
        </div>

        <div className={'account-aufa-end-sum'}>
            <div>
                <p>סה"כ</p>

                <div className={'account-aufa-end-sum-continer'}>
                    <input type='text'
                    placeholder='0'
                    value={cleanAndFormatNumber(inputData.sum)}
                    onChange={(event) => setInputData({...inputData, sum: event.target.value})}
                    style={{'direction': 'ltr'}}
                    />

                    <select value={inputData.coin} onChange={(event) => changeRate(event)}>
                        <option value={'ILS'}>ILS</option>
                        <option value={'USD'}>USD</option>
                    </select>

                </div>
            </div>

            <div className={"account-aufa-end-sum-name"}>
                <p>שם קבלה</p>

                <SelectAndInput
                filter={inputData.name}
                setFilter={(value) => setInputData({...inputData, name: value})}
                dataSelect={
                    Object.values(names).map(item => item["name"])
                }
                />
            </div>

            <div>
                <p>תאריך קבלה</p>
                <input type={'date'} value={inputData.date} onChange={(event) => setInputData({...inputData, date: event.target.value})} />
            </div>
        </div>

        <div className={'account-aufa-route'}>
            <AccountRoute 
            num={numOfRoute} 
            dataToPayment={dataToPayment} 
            setDataToPayment={setDataToPayment} 
            names={names}
            name={inputData.name}
            />
        </div>

        <div className={'account-aufa-payment'}>
            <p onClick={createPayment} >ביצוע תשלום</p>
            <p>סגירה</p>
        </div>
    </>)
}

export default AccountEnd;